<template>
  <div class="cor">
    <div class="cor-top">
      <Row>
        <Col span="12"/>
        <Col span="10">
          <div class="cor-top-content">
            <h2>天鸿在线核心服务</h2>
            <span>天鸿在线依托软硬件产品,结合专业的设计、开发、实施和保障团队,按照天鸿在线客户服务体系,向客户提供信息化基础建设、智能化工程设计、系统集成、业务系统开发和运维保障管理等全生命周期服务。</span>
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>

    </div>
    <div class="cor-center">
          <CorServiceContent1></CorServiceContent1>
    </div>
  </div>

</template>

<script>
   import CorServiceContent1 from '@/pages/cor-service-content/CorServiceContent1.vue'
    export default {
      name: 'CoreServices',
      components:{CorServiceContent1}
    }
</script>

<style lang="less">
  .cor{
    .cor-top{
      background-size: 100% 100%;
      background-image: url(../assets/img/hxfw-bj.jpg);
      background-repeat: no-repeat;
      height: 3.4rem;
      .cor-top-content{
            margin-top: 1.5rem;
            padding-right: 0.5rem;
            text-align: right;
            h2{
              margin-bottom: 0.2rem;
              	font-family: SourceHanSansCN-Medium;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
            }
            span{
              	font-family: MicrosoftYaHeiLight;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
            }
        }
      }
      .cor-center{
        background-image: linear-gradient(#f4f5fa, #fdfdfd);
      }
  }

</style>



// WEBPACK FOOTER //
// src/pages/CoreServices.vue